import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import DonateSheet from '../components/donate/DonateSheet.svelte';
import Card from '../components/shared/Card.svelte';

var root_2 = $.from_html(`<div class="info-card svelte-10jottufr02vz"><h3 class="svelte-10jottufr02vz">Where does it go?</h3> <ul class="svelte-10jottufr02vz"><li class="svelte-10jottufr02vz">Server & hosting costs</li> <li class="svelte-10jottufr02vz">Development time</li> <li class="svelte-10jottufr02vz">Keeping the app ad-free</li></ul></div>`);
var root_3 = $.from_html(`<div class="info-card svelte-10jottufr02vz"><h3 class="svelte-10jottufr02vz">Every bit counts</h3> <p class="svelte-10jottufr02vz">$5/month covers the hosting for one family. Thank you for supporting parents everywhere.</p></div>`);
var root = $.from_html(`<!> <div class="donate-page svelte-10jottufr02vz"><div class="donate-hero svelte-10jottufr02vz"><span class="donate-heart svelte-10jottufr02vz">💛</span> <h2 class="svelte-10jottufr02vz">Help keep mamaobaby free</h2> <p class="donate-subtitle svelte-10jottufr02vz">mamaobaby is free forever, with no ads and no paywalls. Your donation helps cover hosting and development costs.</p></div> <!> <div class="info-cards svelte-10jottufr02vz"><!> <!></div></div>`, 1);

function Donate($$anchor) {
	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'Donate', showBack: true, backPath: '/more' });

	var div = $.sibling(node, 2);
	var node_1 = $.sibling($.child(div), 2);

	Card(node_1, {
		padding: 'lg',
		children: ($$anchor, $$slotProps) => {
			var fragment_1 = $.comment();
			var node_2 = $.first_child(fragment_1);

			DonateSheet(node_2, {});
			$.append($$anchor, fragment_1);
		},
		$$slots: { default: true }
	});

	var div_1 = $.sibling(node_1, 2);
	var node_3 = $.child(div_1);

	Card(node_3, {
		padding: 'md',
		children: ($$anchor, $$slotProps) => {
			var div_2 = root_2();

			$.append($$anchor, div_2);
		},
		$$slots: { default: true }
	});

	var node_4 = $.sibling(node_3, 2);

	Card(node_4, {
		padding: 'md',
		children: ($$anchor, $$slotProps) => {
			var div_3 = root_3();

			$.append($$anchor, div_3);
		},
		$$slots: { default: true }
	});

	$.reset(div_1);
	$.reset(div);
	$.append($$anchor, fragment);
}

if (import.meta.hot) {
	Donate = $.hmr(Donate);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-10jottufr02vz');
		Donate[$.HMR].update(module.default);
	});
}

export default Donate;
import "bun-svelte:Donate.svelte-fdtsn8roc1sc-style.css";